<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <page-header :title="title" />

          <div class="card main-card">
            <div class="card-body">
              <div class="search-section">
                <div class="row">
                  <div class="col-md-5 col-sm-4">
                    <div class="form-wrap icon-form">
                      <span class="form-icon"><i class="ti ti-search"></i></span>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Search by Number, Subject or Organisation"
                        v-model="searchQuery"
                        @input="searchCases(1)"
                      />
                    </div>
                  </div>
                  <div class="col-md-7 col-sm-8">
                    <div class="export-list text-sm-end">
                      <ul class="d-flex gap-2 justify-content-end">
                        <li>
                          <div class="form-sorts dropdown">
                            <a href="javascript:void(0);" data-bs-toggle="dropdown" data-bs-auto-close="outside">
                              <i class="ti ti-filter-share"></i> Filter
                            </a>
                            <div class="filter-dropdown-menu dropdown-menu dropdown-menu-xl-end">
                              <div class="filter-set-view">
                                <div class="filter-set-head">
                                  <h4><i class="ti ti-filter-share"></i> Filter</h4>
                                </div>
                                <div class="filter-content-list">
                                  <label class="mb-2">Status</label>
                                  <select class="form-select" v-model="filters.status">
                                    <option value="">All</option>
                                    <option v-for="opt in statusOptions" :key="opt.value" :value="opt.value">
                                      {{ opt.text }}
                                    </option>
                                  </select>
                                </div>
                                <div class="filter-content-list">
                                  <label class="mb-2">Type</label>
                                  <select class="form-select" v-model="filters.type">
                                    <option value="">All</option>
                                    <option v-for="opt in typeOptions" :key="opt.value" :value="opt.value">
                                      {{ opt.text }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <div class="filter-reset-btns">
                                <div class="row">
                                  <div class="col-6">
                                    <a href="javascript:void(0);" class="btn btn-light" @click="resetFilters">Reset</a>
                                  </div>
                                  <div class="col-6">
                                    <a href="javascript:void(0);" class="btn btn-primary" @click="applyFilters">Filter</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="table-responsive custom-table">
                <org-support-cases-table
                  ref="caseTable"
                  :search-query="searchQuery"
                  :filters="appliedFilters"
                />
              </div>
              <div class="row align-items-center">
                <div class="col-md-6">
                  <div class="datatable-length"></div>
                </div>
                <div class="col-md-6">
                  <div class="datatable-paginate"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, nextTick } from 'vue';
import { useStore } from 'vuex';

export default {
  setup() {
    const store = useStore();
    const title = 'Support Cases';
    const searchQuery = ref('');
    const caseTable = ref(null);
    const filters = ref({ status: '', type: '' });
    const appliedFilters = ref({ status: '', type: '' });

    const dropdowns = computed(() => store.getters['orgSupportCases/getOrgSupportCaseDropdowns'] || {});
    const statusOptions = computed(() => dropdowns.value.support_status || []);
    const typeOptions = computed(() => dropdowns.value.support_type || []);

    const searchCases = async (page = 1) => {
      await nextTick();
      caseTable.value?.fetchCases?.(page);
    };

    const applyFilters = () => {
      appliedFilters.value = { ...filters.value };
      nextTick(() => searchCases(1));
    };

    const resetFilters = () => {
      filters.value = { status: '', type: '' };
      applyFilters();
    };

    onMounted(async () => {
      await store.dispatch('orgSupportCases/fetchOrgSupportCaseOptions');
    });

    return {
      title,
      searchQuery,
      caseTable,
      filters,
      appliedFilters,
      statusOptions,
      typeOptions,
      searchCases,
      applyFilters,
      resetFilters,
    };
  },
};
</script>
